import React from "react";

// Image
import serviceImg from "../../assets/images/aboutServiceImg.svg";

//  Style \\
import "../../assets/styles/cards/freeCheckCard2.scss";

const BloodBank2 = () => {
  return (
    <div>
      <div className="cardFreeCheck2">
        <div className="image">
          <img src={serviceImg} alt="" />
        </div>
        BloodBank2
        <div className="desc">
          <div className="moto">
            <h4>A passion for putting patients first</h4>
          </div>

          <div className="plusSides">
            <div className="box">
              <div className="each">
                <div className="dot"></div>
                <p>A Passion for Healing</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>5-Star Care</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>A Legacy of Excellence</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>All our best</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Believe in Us</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Always Caring</p>
              </div>
            </div>
          </div>

          <div className="com">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              placerat scelerisque tortor ornare ornare. Quisque placerat
              scelerisque tortor ornare ornare Convallis felis vitae tortor
              augue. Velit nascetur proin massa in. Consequat faucibus porttitor
              enim et.
            </p>
            <p className="two">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              placerat scelerisque. Convallis felis vitae tortor augue. Velit
              nascetur proin massa in.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BloodBank2;
